import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsCO: CultureInfo = {
  name: 'es-CO',
  displayName: 'Spanish (Colombia)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-CO',
  parent: CultureInfoEs
};
